module.exports = __webpack_public_path__ + "static/scale-model-of-duke-homestead-in-durham-north-carolina-22cd6696048a4b89b99ccee1ab0a1653.png";